import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    DialogActions,
    MenuItem,
    FormControlLabel,
    Switch
} from "@mui/material";

// Esquema de validación con Yup
const schema = yup.object().shape({
    vennom: yup.string().required("El nombre de la ventana es obligatorio"),
    venurl: yup.string().required("Debe ser una URL válida").required("La URL es obligatoria"),
    venlin: yup.string().required("El link de la ventana es obligatorio"),
    venctr: yup.string().required("Máximo 100 caracteres"),
    venico: yup.string().max(100, "Máximo 100 caracteres"),
    venestvis: yup.boolean().required("El estado de visibilidad es obligatorio"),
    venest: yup
        .string()
        .oneOf(["ACTIVO", "INACTIVO"], "El estado debe ser ACTIVO o INACTIVO")
        .required("El estado es obligatorio"),
});

const WindowForm = ({ open, handleClose, onSubmit, defaultValues = {} }) => {
    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues, // 🔹 Usar los valores por defecto
    });

    // Resetear el formulario cuando cambia `defaultValues` o se cierra el modal
    useEffect(() => {
        if (open) {
            reset(defaultValues); // 🔹 Resetear con los valores por defecto
        }
    }, [open, defaultValues, reset]);

    const handleFormClose = () => {
        reset(); // 🔹 Resetea el formulario
        handleClose(); // 🔹 Cierra el modal
    };

    return (
        <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="sm">
            <DialogTitle>
                {defaultValues?.venid ? "Editar Ventana" : "Crear Ventana"}
            </DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent>
                    {/* Nombre de la ventana */}
                    <TextField
                        label="Nombre de la Ventana"
                        fullWidth
                        margin="normal"
                        {...register("vennom")}
                        error={!!errors.vennom}
                        helperText={errors.vennom?.message}
                    />

                    {/* URL */}
                    <TextField
                        label="URL de la Ventana"
                        fullWidth
                        margin="normal"
                        {...register("venurl")}
                        error={!!errors.venurl}
                        helperText={errors.venurl?.message}
                    />

                    {/* Link */}
                    <TextField
                        label="Link de la Ventana"
                        fullWidth
                        margin="normal"
                        {...register("venlin")}
                        error={!!errors.venlin}
                        helperText={errors.venlin?.message}
                    />

                    {/* Controlador */}
                    <TextField
                        label="Controlador"
                        fullWidth
                        margin="normal"
                        {...register("venctr")}
                        error={!!errors.venctr}
                        helperText={errors.venctr?.message}
                    />

                    {/* Icono */}
                    <TextField
                        label="Ícono"
                        fullWidth
                        margin="normal"
                        {...register("venico")}
                        error={!!errors.venico}
                        helperText={errors.venico?.message}
                    />

                    {/* Estado */}
                    <Controller
                        name="venest"
                        control={control}
                        defaultValue={defaultValues?.venest || "ACTIVO"}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Estado"
                                fullWidth
                                margin="normal"
                                error={!!errors.venest}
                                helperText={errors.venest?.message}
                            >
                                <MenuItem value="ACTIVO">ACTIVO</MenuItem>
                                <MenuItem value="INACTIVO">INACTIVO</MenuItem>
                            </TextField>
                        )}
                    />
                    {/* Estado de la Vista de la Ventana */}
                    <Controller
                        name="venestvis"
                        control={control}
                        defaultValue={defaultValues?.venestvis ?? true}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...field}
                                        checked={field.value}
                                        onChange={(e) => field.onChange(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label={field.value ? "Visible" : "Oculto"}
                            />
                        )}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleFormClose}>Cancelar</Button>
                    <Button type="submit" variant="contained">
                        {defaultValues?.venid ? "Actualizar" : "Guardar"}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default WindowForm;